import React from 'react';

interface SignalIconProps {
    lq: number;
}

/** Signal strength icon — lq is 0-255 (zigbee-herdsman scale) */
const SignalIcon: React.FC<SignalIconProps> = ({ lq }) => {
    const bars = lq >= 192 ? 4 : lq >= 128 ? 3 : lq >= 64 ? 2 : 1;
    const color = lq >= 192 ? '#28a745' : lq >= 128 ? '#7cb342' : lq >= 64 ? '#ffa000' : '#dc3545';
    const label = lq >= 192 ? 'Mycket bra signal' : lq >= 128 ? 'Bra signal' : lq >= 64 ? 'Svag signal' : 'Mycket svag signal';
    const heights = [4, 7, 10, 13];
    return (
        <span title={`${label} (${lq}/255)`} style={{ display: 'inline-flex', alignItems: 'flex-end', gap: '2px', cursor: 'default' }}>
            {heights.map((h, i) => (
                <span key={i} style={{
                    display: 'inline-block',
                    width: '5px',
                    height: `${h}px`,
                    backgroundColor: i < bars ? color : '#ddd',
                    borderRadius: '1px',
                }} />
            ))}
        </span>
    );
};

export default SignalIcon;
